<div class="backdrop" [ngClass]="{ 'backdrop-visible': drawer.opened }" (click)="toggleFilters()"></div>
<mat-sidenav
  #filterDrawer
  class="right-side-nav-container display-flex"
  opened="false"
  position="end"
  mode="over"
  [fixedInViewport]="true"
>
  <div mat-dialog-title>
    <div class="row row--space-between mb--sm">
      <label>{{ 'App.FiltersDrawer.Labels.Filters' | translate }}</label>
      <button mat-button class="float-right" (click)="toggleFilters()">
        <span class="icon-x"></span>
      </button>
    </div>
  </div>

  <div mat-dialog-content>
    <form [formGroup]="filtersForm">
    <div *ngFor="let filter of activeFilters">
      <mat-accordion>
        <mat-expansion-panel
          class="mat-elevation-z0 mb--sm"
          (opened)="panelOpenState.set(true)"
          (closed)="panelOpenState.set(false)"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div>
                <span>{{ 'App.FiltersDrawer.Filters.' + filter || filter | translate }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container [ngSwitch]="filters.get(filter)?.type">
            <!-- MultiSelect Field -->
            <mat-selection-list
              *ngSwitchCase="filterType.MultiSelect"
              [formControlName]="filter"
              class="scrollable-list"
            >
              <mat-list-option
                checkboxPosition="before"
                (click)="toggleAll($event, filter)"
                [selected]="isAllSelected(filter)"
              >
                {{ 'App.FiltersDrawer.All' | translate }}
              </mat-list-option>
              <mat-list-option
                checkboxPosition="before"
                *ngFor="let option of filters.get(filter)?.options"
                [value]="option"
                >{{ option.value | translate }}</mat-list-option
              >
            </mat-selection-list>

            <!-- DateRange Field -->
            <mat-form-field *ngSwitchCase="filterType.DateRange" appearance="outline">
              <mat-label>{{ 'App.FiltersDrawer.FilterPlaceholders.DateRange' | translate }}</mat-label>
              <mat-date-range-input [rangePicker]="picker" [formGroup]="filtersForm" [formGroupName]="filter">
                <input
                  matStartDate
                  formControlName="{{ filter + 'Start' }}"
                  [placeholder]="'App.FiltersDrawer.FilterPlaceholders.StartDate' | translate"
                  [required]="!!filtersForm.get(filter)?.errors"
                />
                <input
                  matEndDate
                  formControlName="{{ filter + 'End' }}"
                  [placeholder]="'App.FiltersDrawer.FilterPlaceholders.EndDate' | translate"
                  [required]="!!filtersForm.get(filter)?.errors"
                />
              </mat-date-range-input>
              <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker touchUi #picker></mat-date-range-picker>
              <mat-error>
                {{ 'App.FiltersDrawer.Messages.InvalidInput' | translate }}
              </mat-error>
            </mat-form-field>

            <!-- Default - Text Field -->
            <mat-form-field *ngSwitchDefault hideRequiredMarker appearance="outline">
              <mat-label>{{ 'App.FiltersDrawer.FilterPlaceholders.' + filter || filter | translate }}</mat-label>
              <input matInput [formControlName]="filter" />
            </mat-form-field>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    </form>
  </div>

  <div mat-dialog-actions class="mt--auto">
    <button
      mat-button
      class="primary-button rounded w-100 mb--sm"
      (click)="onApplyFilters()"
      [disabled]="filtersForm.invalid"
    >
      <span>{{ 'App.FiltersDrawer.Buttons.ApplyFilter' | translate }}</span>
    </button>
    <button mat-button class="hollow-button rounded w-100" (click)="onClearFilters()">
      <span>{{ 'App.FiltersDrawer.Buttons.ClearAll' | translate }}</span>
    </button>
  </div>
</mat-sidenav>
